var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo-background order-1 order-xl-2"},[_c('a',{attrs:{"href":_vm.url,"title":_vm.title}},[_c('img',{staticClass:"logo",attrs:{"src":_vm.image}})])])}
var staticRenderFns = []

export { render, staticRenderFns }